import React from 'react';
import Omega3OrderUpsell from '../Omega3OrderUpsell';
import FormulaUpgradeOffer from './FormulaUpgradeOffer';
import OfferCountdown from './OfferCountdown';
import OrderPaidSummary from './OrderPaidSummary';
import ProgressStepper from './ProgressStepper';
import { OFFER_TYPE_OMEGA3, STEP_OFFER } from '../../../utils/orderCompleteUpsell';

const PostPurchaseOfferStep = ({ orderData, onAccept, onDecline, onExpire, isLoading }) => {
  const postPurchaseUpsell = orderData?.postPurchaseUpsell || {};
  const isOmega3Offer = postPurchaseUpsell.type === OFFER_TYPE_OMEGA3;

  return (
    <div className="t-flex t-flex-col t-gap-3.5">
      <OrderPaidSummary orderData={orderData} postPurchaseUpsell={postPurchaseUpsell} />
      <div className="t-h-px t-bg-gray-200 t--mx-4" />
      <ProgressStepper currentStep={STEP_OFFER} />
      <OfferCountdown
        expiresAt={postPurchaseUpsell.expiresAt}
        serverNow={postPurchaseUpsell.serverNow}
        onExpire={onExpire}
      />
      {isOmega3Offer ? (
        <Omega3OrderUpsell
          onAddToOrder={() => onAccept({ shouldToast: false })}
          onDismiss={onDecline}
          originalPrice={postPurchaseUpsell.pricing?.originalPrice}
          discountedPrice={postPurchaseUpsell.pricing?.discountedPrice}
          discountPercent={postPurchaseUpsell.pricing?.discountPercent}
          durationLabel={postPurchaseUpsell.pricing?.durationLabel}
        />
      ) : (
        <FormulaUpgradeOffer
          postPurchaseUpsell={postPurchaseUpsell}
          onAccept={onAccept}
          onDecline={onDecline}
          isLoading={isLoading}
        />
      )}
    </div>
  );
};

export default PostPurchaseOfferStep;
